export enum completeProfileRoutes {
  completeProfile = 'addDetails',
}
